// extracted by mini-css-extract-plugin
export default {"icon":"navigation_icon__rFXrC"};